import { SalesChannelType } from '../core';
import { AutorenewalType } from '../membership';

export interface ShoppingCart {
  /** If it's an existing shopping cart then the id of the cart. */
  id?: string;
  /**
   * ACME internal use only. Use `customerId` below.
   * @internal
   * */
  tempVisitorId?: string;
  /**
   * ACME internal use only. Use `customerId` below.
   * @internal
   * */
  visitorId?: string;
  /**
   * ACME internal use only. Use `membershipIds` below.
   * @internal
   * */
  membershipId?: string;
  /**
   * The ID of the level.
   * If you don't have the membership id but know the membership level then you can pass this in to give them membership discounts and access.
   * If you pass in a membership id then this will not be used.
   */
  membershipCategoryId?: string;
  /**
   * ACME internal use only.
   * Use couponCodes below.
   * Populating this field will cause the coupons to not be applied to the cart.
   * @internal
   */
  couponCode?: string;
  /**
   * A list of items in the shopping cart.
   */
  items: ShoppingCartItem[];
  /**
   * A list of combo items in the cart.
   * This is for a combo event not combo ticket category.
   */
  comboItems?: ShoppingCartComboItem[];
  /**
   * ACME internal use only.
   * @internal
   */
  forms?: any[];
  /**
   * A list of coupon codes being applied to this cart.
   */
  couponCodes?: string[];
  /**
   * The id of an existing customer.
   * This is ignored when creating a cart outside of checkout. A new customer can be created during B2C Checkout.
   */
  customerId?: string;
  /**
   * A list of membership IDs that are being used on the order
   */
  membershipIds?: string[];
  /**
   * ACME internal use only.
   * @internal
   */
  orderContact?: string;
  /**
   * The sales channel that this order was completed on.
   * one of (online, customerRep, pointOfSale, reseller, kiosk or collaborator)
   */
  saleChannel: SalesChannelType;
  /**
   * ACME internal use only.
   * @internal
   */
  org?: string;
}

export interface ShoppingCartItem {}

export interface ShoppingCartComboItem {}

export interface AutorenewInCart {
  autorenewalType: AutorenewalType;
  /**
   * `autorenewalType` is set to `'optional'` or `'required'`
   */
  isAutorenew: boolean;
  /**
   * Member has opted in to Autorenew
   */
  enabled: boolean;
}

export function createAutorenewInCart(
  values: Partial<Pick<AutorenewInCart, 'autorenewalType' | 'enabled'>> = {}
): AutorenewInCart {
  return {
    autorenewalType: values.autorenewalType || 'none',
    isAutorenew: ['optional', 'required'].includes(values.autorenewalType ?? ''),
    enabled: values.enabled || false,
  };
}
